var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing"},[_c('LandingHeader'),_c('LandingVideo'),_c('ActiveChains'),_c('LandingDescription'),_c('CoreFeatures'),_c('MilkContainer'),_c('Roadmap'),_c('img',{staticClass:"new-year new-year__landing-footer",attrs:{"src":require("@/assets/img/new-year/landing-footer.svg"),"alt":"new-year"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }